import { render, staticRenderFns } from "./PostComments.vue?vue&type=template&id=5298ad79&scoped=true&"
import script from "./PostComments.vue?vue&type=script&lang=js&"
export * from "./PostComments.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/post/PostComments/PostCommentsStyle.css?vue&type=style&index=0&id=5298ad79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5298ad79",
  null
  
)

export default component.exports